import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Customer } from './customer.models';

export const AuthorizationCustomerActions = createActionGroup({
  source: 'Authorization Customer',
  events: {
    Load: emptyProps(),
    Update: props<{ payload: Customer }>(),
    Clear: emptyProps(),
    'Load from Register API': props<{ customer: Customer }>(),
  },
});

export const AuthorizationCustomerApiActions = createActionGroup({
  source: 'Authorization Customer API',
  events: {
    'Load Success': props<{ customer: Customer }>(),
    'Load Failure': emptyProps(),
    'Update Success': props<{ customer: Customer }>(),
    'Update Failure': emptyProps(),
  },
});
